// @ts-nocheck
import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useLastSeen() {
  useEffect(() => {
    let timer: number | null = null;
    const ping = async () => {
      try {
        await supabase.rpc('update_last_seen');
      } catch {}
    };
    ping();
    timer = window.setInterval(ping, 60000);
    return () => { if (timer) clearInterval(timer); };
  }, []);
}


